import {Component, Input} from '@angular/core';
import {CIRCULATION_ITEM_STATUS, CirculationItem} from '@raven';

@Component({
  selector: 'rn-circulation-item-status-pill',
  templateUrl: './circulation-item-status-pill.component.html',
  standalone: false
})
export class CirculationItemStatusPillComponent {
  @Input() item: CirculationItem;
  CIRCULATION_ITEM_STATUS = CIRCULATION_ITEM_STATUS;
}
